import React from 'react';
import { ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router';
import { RoutePath } from 'data';
import { __WsPanelProps } from './wsPanel.interface';
import WorkspacePanel from './wsList/wsPanelList.index';
import WorkspaceDetail from './wsDetail/wsDetail.index';
import FormAnswerList from './answerList/answerList.index';
import FormAnswerDetail from './answerDetail/answerDetail.index';

const Panel: React.FC<ConnectedProps<typeof connector> & __WsPanelProps> = function (
    props: ConnectedProps<typeof connector> & __WsPanelProps,
) {
    return (
        <div className="ucheck-kiosk-form-detail">
            <Switch>
                <Route path={RoutePath.dashboard.formAnswerDetail(':form', ':answer')}>
                    <FormAnswerDetail />
                </Route>
                <Route path={RoutePath.dashboard.formAnswerList(':form')}>
                    <FormAnswerList />
                </Route>
                <Route path={RoutePath.dashboard.wsDetail(':wsId')}>
                    <WorkspaceDetail onRefresh={props.onRefresh} />
                </Route>
                <Route path={RoutePath.dashboard.index}>
                    <WorkspacePanel onRefresh={props.onRefresh} />
                </Route>
                <Route path="*">
                    <Redirect to={RoutePath.dashboard.index} />
                </Route>
            </Switch>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(Panel);
